import React, { useState, useEffect, Fragment } from 'react';
import { connect } from 'react-redux';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { DataGridPro, GridToolbarContainer, GridToolbarExport } from '@mui/x-data-grid-pro';
import TFFunnel from '../../Charts/Funnel';
import TFBar from '../../Charts/Bar';


const Conversions = ( { meta, user, viewing, canExport, opps, loans, start, end, purpose, source } ) => {
    const [ colsSource, setColsSource ] = useState( [] );
    const [ cohort, setCohort ] = useState( [] );
    const [ leads, setLeads ] = useState( { id: 'leads', milestone: 'Leads', total: 0 } );
    const [ apps, setApps ] = useState( { id: 'apps', milestone: 'Apps', total: 0 } );
    const [ pas, setPAs ] = useState( { id: 'pas', milestone: 'PAs', total: 0 } );
    const [ locks, setLocks ] = useState( { id: 'locks', milestone: 'Locks', total: 0 } );
    const [ funded, setFunded ] = useState( { id: 'funded', milestone: 'Fundings', total: 0 } );
    const [ rows, setRows ] = useState( [] );
    const [ m2mData, setM2mData ] = useState( [ { name: 'Loading...', values: [ 0, 0, 0 ] } ] );
    const [ subtitle, setSubtitle ] = useState( '' );
    
    const toolbar = () => {
        return(
            <GridToolbarContainer>
                <Container fluid className='p-0'>
                    <Row className='p-0 align-items-center w-100'>
                        <Col></Col>
                        {
                            ( canExport ) ? (
                                <Col xs='auto' className='pe-3 text-right'>
                                    <GridToolbarExport />
                                </Col>
                            ) : (
                                null
                            )
                        }
                    </Row>
                </Container>
            </GridToolbarContainer>
        )
    }

    useEffect( () => {
        if ( meta?.global?.picklist?.source ) {
            let cols = [ { field: 'milestone', headerName: '', flex: 1, cellClassName: 'tf-metrics-grid-row-label' } ];
            cols.push( { field: 'total', headerName: 'Total', flex: 1, cellClassName: 'tf-metrics-grid-total' } );
            setColsSource( cols );
        }
    }, [ meta ] );

    useEffect( () => {
        let list = [
            { name: 'Leads-to-Apps', amt: 0 },
            { name: 'Apps-to-PAs', amt: 0 },
            { name: 'PAs-to-Locks', amt: 0 },
            { name: 'Locks-to-Fundings', amt: 0 }
        ];

        if ( leads.total && apps.total ) {
            list[0].amt = apps.total / leads.total * 100;
        }
        if ( apps.total && pas.total ) {
            list[1].amt = pas.total / apps.total * 100;
        }
        if ( pas.total && locks.total ) {
            list[2].amt = locks.total / pas.total * 100;
        }
        if ( locks.total && funded.total ) {
            list[3].amt = funded.total / locks.total * 100;
        }

        setM2mData( list );
        setRows( [ leads, apps, pas, locks, funded ] );
    }, [ leads, apps, pas, locks, funded ] );

    useEffect( () => {
        console.log( 'rows: ', rows );
    }, [ rows ] );

    useEffect( () => {
        let sub = '';

        if ( purpose && purpose !== '*' ) {
            sub = `${purpose} Leads`;
            if ( source && source !== '*' ) {
                sub += ` from ${source}s`;
            }
        } else if ( source && source !== '*' ) {
            sub = `${source} Leads`;
        }

        setSubtitle( sub );
    }, [ purpose, source ] );

    useEffect( () => {
        let row = { id: 'leads', milestone: 'Leads', total: 0 };
        let list = [];
        // meta.global.picklist.source.forEach( s => row[s.reportLabel] = 0 );
        
        if ( opps ) {
            const sd = new Date( start + 'T12:00:00.000' );
            const ed = new Date( end + 'T12:00:00.000' );

            Object.keys( opps ).forEach( loid => {
                const lo = opps[loid];
                if ( !viewing.includes( lo.aid ) ) {
                    return;
                }

                if ( lo.oppDate ) {
                    const od = new Date( lo.oppDate + 'T12:00:00.000' );
                    if ( od.getTime() >= sd.getTime() && od.getTime() <= ed.getTime() ) {
                        if ( ( purpose === '*' || purpose === lo.purpose ) && ( source === '*' || source === lo.source ) ) {
                            list.push( lo );
                            row.total++;
                        }
                    }
                }
            } );
        }

        setCohort( list );
        setLeads( row );
    }, [ opps, start, end, purpose, source, viewing ] );

    useEffect( () => {
        let apps = { id: 'apps', milestone: 'Apps', total: 0 };
        let pas = { id: 'pas', milestone: 'PAs', total: 0 };
        let locks = { id: 'locks', milestone: 'Locks', total: 0 };
        let funded = { id: 'funded', milestone: 'Fundings', total: 0 };

        if ( cohort && loans ) {
            const sd = new Date( start + 'T12:00:00.000' );
            const ed = new Date( end + 'T12:00:00.000' );

            for ( let i = 0; i < cohort.length; i++ ) {
                const lo = cohort[i];
                // console.log( 'lo: ', lo );
                if ( !viewing.includes( lo.aid ) ) {
                    continue;
                }

                if ( lo.relationships[0]?.lid ) {
                    const l = loans[lo.relationships[0].lid];
                    if ( !l ) {
                        console.log( '***** No loan for lid: ', lo );
                        continue;
                    }

                    // App
                    if ( l.appCompletedDate ) {
                        const acd = new Date( l.appCompletedDate );
                        acd.setHours( 12, 0, 0, 0 );
                        if ( acd.getTime() >= sd.getTime() && acd.getTime() <= ed.getTime() ) {
                            apps.total++;
                        }
                    }

                    // PA
                    if ( l.paDate ) {
                        const pad = new Date( l.paDate + 'T12:00:00.000' );
                        if ( pad.getTime() >= sd.getTime() && pad.getTime() <= ed.getTime() ) {
                            pas.total++;
                        }
                    }

                    // Locks
                    if ( l.rateLockDate ) {
                        const rld = new Date( l.rateLockDate + 'T12:00:00.000' );
                        if ( rld.getTime() >= sd.getTime() && rld.getTime() <= ed.getTime() ) {
                            locks.total++;
                        }
                    }

                    // Funded
                    if ( l.fundedDate ) {
                        const fd = new Date( l.fundedDate + 'T12:00:00.000' );
                        if ( fd.getTime() >= sd.getTime() && fd.getTime() <= ed.getTime() ) {
                            funded.total++;
                        }
                    }
                }
            }
        }

        setApps( apps );
        setPAs( pas );
        setLocks( locks );
        setFunded( funded );
    }, [ cohort, loans, start, end, meta.global.picklist.source, viewing ] );

    return (
        <Container fluid>
            <Row>
                <Col xs={6} className='p-0'>
                    <Row className='text-center pt-3'>
                        <Col style={ { fontSize: '22px' } }>Lead-to-Milestone Conversions</Col>
                    </Row>
                    {
                        ( subtitle.length ) ? (
                            <Row className='text-center py-0'>
                                <Col style={ { fontSize: '16px' } }>
                                    {subtitle}
                                </Col>
                            </Row>
                        ) : (
                            null
                        )
                    }
                    <Row className='pt-3'>
                        <Col className='px-3'>
                            <TFFunnel data={ rows } title='Lead-to-Milestone Conversions' />
                        </Col>
                    </Row>
                </Col>
                <Col xs={6} className='p-0'>
                    <Row className='text-center pt-3'>
                        <Col style={ { fontSize: '22px' } }>Milestone-to-Milestone Conversions</Col>
                    </Row>
                    {
                        ( subtitle.length ) ? (
                            <Row className='text-center py-0'>
                                <Col style={ { fontSize: '16px' } }>
                                    {subtitle}
                                </Col>
                            </Row>
                        ) : (
                            null
                        )
                    }
                    <Row className='pt-3'>
                        <Col className='px-3'>
                            <TFBar data={m2mData} h={325} />
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Container>
    )
}

const mapProps = ( state ) =>( {
    aid: state.user.aid,
    meta: state.user.meta,
    user: state.user,
    viewing: state.user.viewing,
    canExport: state.user.canExport,
    opps: state.leadopps.byId,
    loans: state.loans.byId
} );

const mapDispatch = ( dispatch ) => ( {
} );

export default connect( mapProps, mapDispatch )( Conversions );